(function () {
  'use strict';

  var STORAGE_KEY = 'ia_player_state';
  var BAR_COUNT = 80;
  var audio = new Audio();
  var queue = [];
  var currentIndex = 0;

  var player         = document.getElementById('ia-sticky-player');
  var titleEl        = document.getElementById('ia-track-title');
  var artistEl       = document.getElementById('ia-track-artist');
  var playPauseBtn   = document.getElementById('ia-playpause');
  var prevBtn        = document.getElementById('ia-prev');
  var nextBtn        = document.getElementById('ia-next');
  var closeBtn       = document.getElementById('ia-close');
  var scrubber       = document.getElementById('ia-scrubber');
  var timeEl         = document.getElementById('ia-time');
  var iconPlay       = playPauseBtn ? playPauseBtn.querySelector('.ia-icon-play')  : null;
  var iconPause      = playPauseBtn ? playPauseBtn.querySelector('.ia-icon-pause') : null;
  var playlistPanel  = document.getElementById('ia-playlist-panel');
  var playlistClose  = document.getElementById('ia-playlist-close');
  var playlistTracks = document.getElementById('ia-playlist-tracks');
  var queueToggle    = document.getElementById('ia-queue-toggle');
  var waveformBg     = document.querySelector('.ia-player__waveform-bg');
  var waveformFillEl = document.querySelector('.ia-player__waveform-fill');
  var playhead       = document.querySelector('.ia-player__playhead');

  if (!player) return;

  // ── Waveform bar generation ───────────────────────────────────────────────

  function generateBars(container, count) {
    container.innerHTML = '';
    var seed = 12345;
    for (var i = 0; i < count; i++) {
      seed = (seed * 1664525 + 1013904223) & 0xffffffff;
      var h = Math.abs(seed % 60) + 20;
      var bar = document.createElement('div');
      bar.className = 'ia-bar';
      bar.style.height = h + '%';
      container.appendChild(bar);
    }
  }

  if (waveformBg)     generateBars(waveformBg, BAR_COUNT);
  if (waveformFillEl) generateBars(waveformFillEl, BAR_COUNT);

  // ── Helpers ───────────────────────────────────────────────────────────────

  function formatTime(s) {
    if (!s || !isFinite(s)) return '0:00';
    var m = Math.floor(s / 60);
    return m + ':' + String(Math.floor(s % 60)).padStart(2, '0');
  }

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        queue:        queue,
        currentIndex: currentIndex,
        currentTime:  audio.currentTime,
        isPlaying:    !audio.paused,
        src:          audio.src
      }));
    } catch (e) {}
  }

  function loadState() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)); }
    catch (e) { return null; }
  }

  // ── Stop all other audio on the page ─────────────────────────────────────

  function stopAllPageAudio() {
    document.querySelectorAll('audio').forEach(function (el) {
      if (el !== audio) {
        el.pause();
        el.currentTime = 0;
      }
    });
    document.querySelectorAll('.play-btn.playing').forEach(function (btn) {
      btn.classList.remove('playing');
    });
    if (window._iaProductAnimFrame) {
      cancelAnimationFrame(window._iaProductAnimFrame);
      window._iaProductAnimFrame = null;
    }
  }

  // ── UI ────────────────────────────────────────────────────────────────────

  function updateMeta() {
    var track = queue[currentIndex];
    if (!track) return;
    titleEl.textContent  = track.title  || '—';
    artistEl.textContent = track.artist || '—';
  }

  function setPlayingUI(playing) {
    if (iconPlay)  iconPlay.style.display  = playing ? 'none'  : 'block';
    if (iconPause) iconPause.style.display = playing ? 'block' : 'none';
    playPauseBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
  }

  function updateProgress(pct) {
    scrubber.value = pct;
    if (waveformFillEl) {
      waveformFillEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    }
    if (playhead) {
      playhead.style.left = pct + '%';
    }
  }

  function showPlayer() {
    player.classList.add('is-active');
    player.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ia-player-active');
  }

  function hidePlayer() {
    closePlaylist();
    player.classList.remove('is-active');
    player.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ia-player-active');
    audio.pause();
    sessionStorage.removeItem(STORAGE_KEY);
    queue = [];
    currentIndex = 0;
    titleEl.textContent  = '—';
    artistEl.textContent = '—';
    updateProgress(0);
    setPlayingUI(false);
    renderPlaylist();
  }

  // ── Playlist ──────────────────────────────────────────────────────────────

  function renderPlaylist() {
    if (!playlistTracks) return;
    playlistTracks.innerHTML = '';
    queue.forEach(function (track, i) {
      var li = document.createElement('li');
      li.className = 'ia-playlist__track' + (i === currentIndex ? ' is-current' : '');

      var playingIndicator = i === currentIndex
        ? '<svg width="8" height="8" viewBox="0 0 16 16" fill="white"><path d="M4 2l10 6-10 6V2z"/></svg>'
        : (i + 1);

      li.innerHTML =
        '<span class="ia-playlist__track-num' + (i === currentIndex ? ' is-playing' : '') + '">' +
          playingIndicator +
        '</span>' +
        '<div class="ia-playlist__track-info">' +
          '<span class="ia-playlist__track-title">' + (track.title  || 'Track ' + (i + 1)) + '</span>' +
          '<span class="ia-playlist__track-artist">' + (track.artist || '') + '</span>' +
        '</div>' +
        (track.url ? '<a href="' + track.url + '" class="ia-playlist__buy-btn" aria-label="Go to product page">→ BUY</a>' : '');

      li.addEventListener('click', function (e) {
        if (e.target.classList.contains('ia-playlist__buy-btn')) return;
        stopAllPageAudio();
        playTrack(i);
        renderPlaylist();
      });

      playlistTracks.appendChild(li);
    });
  }

  function openPlaylist() {
    if (!playlistPanel || !player.classList.contains('is-active')) return;
    playlistPanel.classList.add('is-open');
    playlistPanel.setAttribute('aria-hidden', 'false');
  }

  function closePlaylist() {
    if (!playlistPanel) return;
    playlistPanel.classList.remove('is-open');
    playlistPanel.setAttribute('aria-hidden', 'true');
  }

  function togglePlaylist() {
    if (!playlistPanel) return;
    playlistPanel.classList.contains('is-open') ? closePlaylist() : openPlaylist();
  }

  if (queueToggle)   queueToggle.addEventListener('click', togglePlaylist);
  if (playlistClose) playlistClose.addEventListener('click', closePlaylist);

  // ── Playback ──────────────────────────────────────────────────────────────

  function loadTrack(index, startTime) {
    startTime = startTime || 0;
    currentIndex = index;
    var track = queue[currentIndex];
    if (!track) return;
    audio.src = track.src;
    updateMeta();
    showPlayer();
    updateProgress(0);

    if (startTime > 0) {
      audio.addEventListener('loadedmetadata', function onMeta() {
        audio.currentTime = startTime;
        audio.removeEventListener('loadedmetadata', onMeta);
      });
    }
  }

  function playTrack(index, startTime) {
    stopAllPageAudio();
    loadTrack(index, startTime);
    renderPlaylist();
    audio.play().catch(function () {
      setPlayingUI(false);
    });
  }

  // ── Controls ──────────────────────────────────────────────────────────────

  playPauseBtn.addEventListener('click', function () {
    if (audio.paused) {
      stopAllPageAudio();
      audio.play().catch(function () {});
    } else {
      audio.pause();
    }
  });

  prevBtn.addEventListener('click', function () {
    if (audio.currentTime > 3 && audio.duration) {
      audio.currentTime = 0;
    } else if (currentIndex > 0) {
      playTrack(currentIndex - 1);
    }
  });

  nextBtn.addEventListener('click', function () {
    if (currentIndex < queue.length - 1) playTrack(currentIndex + 1);
  });

  closeBtn.addEventListener('click', hidePlayer);

  // ── Audio events ──────────────────────────────────────────────────────────

  audio.addEventListener('play',  function () { setPlayingUI(true); });
  audio.addEventListener('pause', function () { setPlayingUI(false); });

  audio.addEventListener('ended', function () {
    setPlayingUI(false);
    if (currentIndex < queue.length - 1) {
      playTrack(currentIndex + 1);
    }
  });

  audio.addEventListener('timeupdate', function () {
    if (!audio.duration || !isFinite(audio.duration)) return;
    var pct = (audio.currentTime / audio.duration) * 100;
    updateProgress(pct);
    timeEl.textContent = formatTime(audio.currentTime) + ' / ' + formatTime(audio.duration);
  });

  audio.addEventListener('error', function () {
    console.warn('IA Player: audio error on', audio.src);
  });

  // ── Scrubber ──────────────────────────────────────────────────────────────

  scrubber.addEventListener('input', function () {
    if (audio.duration && isFinite(audio.duration)) {
      audio.currentTime = (scrubber.value / 100) * audio.duration;
    }
  });

  // ── Persist state — save on navigate ─────────────────────────────────────

  window.addEventListener('pagehide', saveState);

  // ── Restore state — runs immediately on page load ─────────────────────────

  var state = loadState();
  if (state && state.src && state.queue && state.queue.length) {
    queue = state.queue;
    currentIndex = state.currentIndex || 0;

    audio.preload = 'auto';
    audio.src = state.src;

    updateMeta();
    renderPlaylist();
    showPlayer();
    setPlayingUI(false);

    if (state.isPlaying) {

      var immediatePlay = audio.play();
      if (immediatePlay !== undefined) {
        immediatePlay.catch(function () {

          audio.addEventListener('canplay', function onCanPlay() {
            audio.removeEventListener('canplay', onCanPlay);
            if (state.currentTime > 0) {
              audio.currentTime = state.currentTime;
            }
            audio.play().catch(function () {

              function resumeOnTouch() {
                if (state.currentTime > 0) {
                  audio.currentTime = state.currentTime;
                }
                audio.play().catch(function () {});
                document.removeEventListener('touchstart', resumeOnTouch);
                document.removeEventListener('click', resumeOnTouch);
              }
              document.addEventListener('touchstart', resumeOnTouch, { once: true });
              document.addEventListener('click', resumeOnTouch, { once: true });
              setPlayingUI(false);
            });
          });
        });
      }

      if (state.currentTime > 0) {
        audio.addEventListener('loadedmetadata', function onMeta() {
          audio.removeEventListener('loadedmetadata', onMeta);
          audio.currentTime = state.currentTime;
        });
      }

    } else {
      audio.addEventListener('loadedmetadata', function onMeta() {
        audio.removeEventListener('loadedmetadata', onMeta);
        if (state.currentTime > 0) audio.currentTime = state.currentTime;
      });
      setPlayingUI(false);
    }
  }

  // ── Pause player when cart opens, resume when closed ─────────────────────

  function watchCartDrawer() {
    var cartDrawer = document.querySelector('.cart-drawer, x-drawer, [id*="cart-drawer"]');
    if (!cartDrawer) return;

    var observer = new MutationObserver(function () {
      var isOpen =
        cartDrawer.classList.contains('is-open') ||
        cartDrawer.classList.contains('active') ||
        cartDrawer.classList.contains('is-visible') ||
        cartDrawer.hasAttribute('open') ||
        cartDrawer.getAttribute('aria-hidden') === 'false' ||
        cartDrawer.getAttribute('aria-expanded') === 'true';

      if (isOpen && !audio.paused) {
        audio.pause();
        window._iaCartPaused = true;
      } else if (!isOpen && window._iaCartPaused) {
        audio.play().catch(function () {});
        window._iaCartPaused = false;
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'aria-expanded', 'style']
    });
  }

  watchCartDrawer();

  // ── Public API ────────────────────────────────────────────────────────────

  window.IAPlayer = {
    loadQueue: function (tracks, startIndex) {
      queue = tracks;
      stopAllPageAudio();
      playTrack(startIndex || 0);
      renderPlaylist();
    },
    playTrack: playTrack,
    pause:     function () { audio.pause(); },
    getQueue:  function () { return queue; },
    getCurrentIndex: function () { return currentIndex; }
  };

})();
